<div class="container" fxLayout="column" fxLayoutAlign="center flex-end">
  <span class="header">{{header}}</span>
  <form class="fields" [formGroup]="form">
    <input class="amount-field" (keyup)="onAmountChange()" formControlName="amount"
           [placeholder]="calculatedAmount || ''">
    <button class="currency-button" (click)="currencyClick()" fxLayout="row" fxLayoutAlign="flex-end center">
      <b>{{selectedCurrency?.alpha3}}</b>
      <img class="equals-sign" src="assets/arrow_drop_down-black-18dp.svg"/>
    </button>
    <!--    <select #select class="currency-field" (ngModelChange)="onCurrencyChange()"  formControlName="currency" [(ngModel)]="selectedCurrency">&lt;!&ndash;(change)="onCurrencyChange($event)" &ndash;&gt;-->
    <!--      <option *ngFor="let currency of currencies" [ngValue]="currency">{{currency.alpha3}} - {{currency.name}}</option>-->
    <!--    </select>-->
    <mat-select class="select" #matSelect (selectionChange)="onCurrencyChange()" formControlName="currency"
                [(ngModel)]="selectedCurrency">
      <mat-option class="option" *ngFor="let currency of currencies" [value]="currency">{{currency.alpha3}}
        - {{currency.name}} </mat-option>
    </mat-select>
  </form>
  <span class="exchange-rate">{{rate ? rate : 0.000}}</span>
</div>

